import React from 'react';
import { Stack } from '@mui/material';
import prontoPagoData from '../../constants/products/pronto-pago';
import ProductHero from './components/ProductHero';
import ProductSection from './components/ProductSection';
import RecommendationSection from './components/RecommendationSection';
import { STACK_PRODUCT_SECTION_COMPONENT } from '../../constants/mui-components';

function ProntoPago() {
  return (
    <>
      <ProductHero productData={prontoPagoData} />
      <Stack className={STACK_PRODUCT_SECTION_COMPONENT}>
        <ProductSection productData={prontoPagoData.description_information} />
        <ProductSection
          productData={prontoPagoData.benefits_information}
          flexDirection="row-reverse"
        />
        <RecommendationSection actualProductName={prontoPagoData.name} />
      </Stack>
    </>
  );
}

export default ProntoPago;
